var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isVisible)?_c('div',{staticClass:"adjustment-indicator",attrs:{"title":_vm.$t('indicator-title')}},[_c('icon',{attrs:{"name":"adjust","scale":"1.75"}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }